import { DatabaseViewProps } from "./types/databaseViewProps";
import { ReactComponent as DataBase } from "../../../icons/database.svg";
import { iconStyle } from "../../../components/shared/stylization";
import './dataBaseView.scss';
import Table from "../../../components/shared/table/table";
import { CellContext, createColumnHelper, PaginationState, Row } from "@tanstack/react-table";
import { ColumnConfig, ColumnType, TableProps, ThreeDotsTableTypes } from "../../../components/shared/table/types/tableProps";
import TableActions from "../../../components/shared/table/tableActions/tableActions";
import SlideoutWrapper from "../../../components/slideoutWrapper/slideoutWrapper";
import { ReactComponent as MapIcon } from '../../../icons/map.svg';
import { SlideoutBtnPosition } from "../../../components/slideoutWrapper/types/slideoutWrapperProps";
import { useCallback, useContext, useEffect, useRef, useState, useSyncExternalStore } from "react";
import WebMap from "../../../components/webmap/webmap";
import { mapStore } from "../../../stores/mapStore";
import { addProtocol, correctProtocol, queryFeatureSet, tableFeatureService } from "../../../services/arcGisService/arcGisService";
import { apiContext } from "../../../contexts/apiContext";
import Query from "@arcgis/core/rest/support/Query.js";
import { HeadersTable, joinData } from "../../../helpers/featureTableConstruct";
import { buildWhereFromMapToKr, fromTableToMap, getObjKey } from "../../../helpers/map/query";
import { showFeatures } from "../../../helpers/map/map";
import { ArcGisAddProtocolProps, ProtocolIds } from "../../../services/arcGisService/types/arcGisServiceProps";
import { FiltersTable, SortType, TableContext } from "../../../contexts/tableContext";
import { notifyError, notifySuccess } from "../../../components/snackbar/snackbar";
import { ObjectType } from "../../../contexts/types/card";
import PermissionsContext from "../../../contexts/permissionsContext";
import { UpdateRegistrationCard } from "../../../services/registrationCardService/registrationCardService";
import { RegistrationCardIds } from "../../../services/registrationCardService/types/registrationCardServiceProps";
import DeleteTaskWindow from "./deleteTaskWindow";
import { getCorrectFormPermissions } from "../../../helpers/permissionsHelper";
import { ID_NUMBER } from "../../../helpers/idNumber";
import { ObjectCategories } from "../administrationView/AdministrationPermissionExtendedView/types/administrationsPermissionExtendedViewProps";
import { filtersToQuery } from "../../../helpers/filter";
import ViewContext from "../../../contexts/viewContext";
import AuthContext from "../../../contexts/authContext";
import { getTableSettings, setTableSettings } from "../../../database/indexedDbReadWrite";
import UpdateRegistrationCardModal from "./updateRegistrationCardModal/updateRegistrationCardModal";

const DATABASE_TABLE = 'DBT';

const DataBaseView = (props: DatabaseViewProps) => {
    const api = useContext(apiContext);
    const { username } = useContext(AuthContext);
    const { setViewType, viewTypes } = useContext(ViewContext);
    const { checkboxesTable, setCheckboxesTable, reloadTable, setReloadTable, sortConfigDb } = useContext(TableContext); 
    const [headersExtend, setHeadersExtend] = useState<HeadersTable>({});
    const [featureSetExtend, setFeatureSetExtend] = useState<__esri.Graphic[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [deleteObj, setDeleteObj] = useState<boolean>(false);
    const [mapSelection, setMapSelection] = useState<__esri.Graphic[]>([]);
    const [selected, setSelected] = useState<__esri.Graphic[]>([]);
    const customMap = useSyncExternalStore(mapStore.subscribe, mapStore.getSnapshot);
    const { filtersTableDb } = useContext(TableContext);
    const { functionsPermissions, extendedUserPermissions } = useContext(PermissionsContext);
    const [pagination, setPagination] = useState<PaginationState>({ pageIndex: 0, pageSize: 0 });
    const [pageCount, setPageCount] = useState<number>(1);
    const [allCount, setAllCount] = useState<number>(0);
    const [modalCardUpdate, setmodalCardUpdate] = useState(false);
    const [rowKRUpdate, setrowKRUpdate] = useState<any[]>([])

    const tableSelection = useRef<{ [id: string] : __esri.Graphic | null } >({});
    const columnConfig = useRef<ColumnConfig[]>([{name: "DATA_OBS", type: ColumnType.Date}]);

    useEffect(() => {
        setCheckboxesTable([]);
    }, [setCheckboxesTable])

    useEffect(() => {
        if (pagination.pageSize === 0) {
            getTableSettings(username, DATABASE_TABLE).then((tSettings) => {
                setPagination({ pageIndex: 0, pageSize: tSettings.pageSize });
            }, () => {
                setPagination({ pageIndex: 0, pageSize: 10 })
            });
        }
    }, [username, pagination.pageSize])

    const recalcPagination = useCallback((all: number) => {
        const newPageCount = all !== undefined ? Math.ceil(all / pagination.pageSize) : 1;
        if (newPageCount < pagination.pageIndex + 1) {
            const newPageIndex = newPageCount - 1 >= 0 ? newPageCount - 1 : 0;
            setPagination({ pageSize: pagination.pageSize, pageIndex: newPageIndex });
        }
        setPageCount(newPageCount);
        setAllCount(all);
    }, [pagination.pageIndex, pagination.pageSize])

    const onPaginationChange = (name: string, value: any) => {
        if (name === 'pageSize') {
            setTableSettings(username, {name: DATABASE_TABLE, pageSize: value});
        }
    }

    const cellAction = (properties: CellContext<any, unknown>) => {
        return (<TableActions
            row={properties.row}
            objectType="dataBaseView"
            autoRenewClickHandler={handleAutoRenewClick}
            findInPageClickHandler={handleFindInPageClick}
        />)
    }

    const handleAutoRenewClick = (row: any) => {
        let objectType = row.original.attributes.RODZAJ_OBIEKTU;
        let teryts = row.original.attributes.TERYT;
        let isProtocol = objectType === ObjectType.POO || objectType === ObjectType.POTZ;

        if (getCorrectFormPermissions(isProtocol, objectType, teryts, functionsPermissions, extendedUserPermissions) && isProtocol) correctPO([row]);
        else if (getCorrectFormPermissions(isProtocol, objectType, teryts, functionsPermissions, extendedUserPermissions) && !isProtocol) {
            setrowKRUpdate([row]);
            var has2007 = false;
            var has2020 = false;
            var attrs = row.original.attributes;
            if(attrs.WZOR && attrs.WZOR === 2007){
                has2007 = true;
            }
            if(attrs.WZOR && attrs.WZOR === 2020){
                has2020 = true;
            }
            if(!has2007 && has2020){
                updateKR([row]);
            }
            else{
                setmodalCardUpdate(true);
            }
        };
    }

    const handleFindInPageClick = (row: any) => {
        const isLandslide = row.original.attributes.RODZAJ_OBIEKTU === ObjectType.KRO;
        var extPerms = true;
        if (extendedUserPermissions.userObjectCategories && extendedUserPermissions.userObjectCategories?.length! > 0) {
            extPerms = extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.Protocol) &&
            (isLandslide ? extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.Landslide) :
            extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.EndangeredArea))
        }
        
        if (functionsPermissions.addPO.active && extPerms) {
            const url = isLandslide ? api.featureServices.landslide : api.featureServices.endangeredArea;
            var idNumber = row.original.attributes.NUMER_IDENTYFIKACYJNY;
            const where = `${ID_NUMBER}=${idNumber}`;

            addPO(url, idNumber, isLandslide, where);
        }
    }

    const handleThreeDotsAddProtocolClick = () => {
        const isLandslide = checkboxesTable[0].original.attributes.RODZAJ_OBIEKTU === ObjectType.KRO;
        const url = isLandslide ? api.featureServices.landslide : api.featureServices.endangeredArea;
        var idNumber = checkboxesTable[0].original.attributes.NUMER_IDENTYFIKACYJNY;
        const where = `${ID_NUMBER}=${idNumber}`;

        addPO(url, idNumber, isLandslide, where);
    }
    
    const addPO = (url: string, idNumber: string, isLandslide: boolean, where: string) => {
        let arcGisAddProtocolProps: ArcGisAddProtocolProps = {
            url: url,
            idNumber: idNumber,
            isLandslide: isLandslide,
            where: where,
            apiBase: api.apiUrl + api.apiVersion
        }

        setLoading(true);
        addProtocol(arcGisAddProtocolProps)
        .then(() => {
            notifySuccess({ message: "Dodano protokół obserwacji do poczekalni" });
            //setViewType(viewTypes.TaskList);
        })
        .catch(() => {
            notifyError({ message: "Próba dodania protokołu obserwacji zakończona niepowodzeniem" });
        })
        .finally(() => {
            setLoading(false);
        });
    }

    const correctPO = (rows: any[]) => {
        let protocols: ProtocolIds[] = [];
        
        rows.forEach((item: any) => {
            var attrs = item.original.attributes;
            var data: ProtocolIds = {
                globalId: attrs.GLOBALID,
                idNumber: attrs.NUMER_IDENTYFIKACYJNY,
                objectType: attrs.RODZAJ_OBIEKTU,
            };
            protocols.push(data);
        })
        
        setLoading(true);
        correctProtocol(api.apiUrl + api.apiVersion, protocols)
        .then(() => {
            notifySuccess({ message: `Dodano ${protocols.length === 1 ? "protokół" : "protokoły"} do poczekalni`});
            setLoading(false);
            setViewType(viewTypes.TaskList);
        })
        .catch((err: any) => {
            if (err.response.status === 401) notifyError({ message: "Brak wymaganych uprawnień" });
            else notifyError({ message: err.response.data });
            setLoading(false);
        });
    }

    const callbackUpdateKR = (type: number, rows: any[]) => {
        var poChecked = checkboxesTable.filter(item => item.original.attributes.RODZAJ_OBIEKTU === ObjectType.POO || item.original.attributes.RODZAJ_OBIEKTU === ObjectType.POTZ);
        updateKR(rowKRUpdate, type);
        if(poChecked.length > 0) correctPO(poChecked);
        setmodalCardUpdate(false);
    }

    const onCloseModal = () => {
        setmodalCardUpdate(false);
    }

    const updateKR = (rows: any[], type?: number) => {
        let registationCards: RegistrationCardIds[] = [];
        rows.forEach((item: any) => {
            var attrs = item.original.attributes;
            var data: RegistrationCardIds = {
                Type: attrs.RODZAJ_OBIEKTU === ObjectType.KRO ? "osuwisko" : "tz",
                Id: attrs.NUMER_IDENTYFIKACYJNY?.toString(),
                globalId: attrs.GLOBALID,
                cardPattern: type ? type : attrs.WZOR
            };
            registationCards.push(data);
        })
        
        setLoading(true);
        UpdateRegistrationCard(registationCards, api.apiUrl, api.apiVersion)
        .then(() => {
            notifySuccess({ message: `Dodano aktualizację ${registationCards.length === 1 ? "karty rejestracyjnej" : "kart rejestracyjnych"}` });
            setLoading(false);
            setViewType(viewTypes.TaskList);
        })
        .catch((error: any) => {
            if (error.response.status === 401) notifyError({ message: "Brak wymaganych uprawnień" });
            else notifyError({ message: error.response.data });
            setLoading(false);
        });
    }

    const prepareData = useCallback(() => {
        return joinData(featureSetExtend, mapSelection);
    }, [featureSetExtend, mapSelection])

    const handleTrClick = (features: __esri.Graphic[]) => {
        setMapSelection([]);
        setSelected(features);
        const view = mapStore.getView();
        if (view) {
            const tableToMap = fromTableToMap(tableSelection.current, features);
            if (tableToMap.newRec !== null) {
                setLoading(true);

                var objectType = tableToMap.newRec.attributes.RODZAJ_OBIEKTU;
                var idNumber = tableToMap.newRec.attributes.NUMER_IDENTYFIKACYJNY;
                const fKey = getObjKey(objectType, idNumber);
                const query = new Query({
                    outFields: ["NUMER_IDENTYFIKACYJNY"],
                    returnGeometry: true,
                    where: `NUMER_IDENTYFIKACYJNY=${idNumber}`
                })
                const url = objectType === 'KRO' || objectType === 'POO' ? api.featureServices.landslide : api.featureServices.endangeredArea;
                let _query = queryFeatureSet({ url: url }, query);
                _query.promise.then((featureSet: any) => {
                    if (featureSet.data !== null && featureSet.data.length > 0) {
                        tableToMap.ts[fKey] = featureSet.data[0];
                        tableSelection.current = tableToMap.ts;
                    } else {
                        tableToMap.ts[fKey] = null;
                        tableSelection.current = tableToMap.ts;
                    }
                    const toShowFeatures = filterShowFeatures(tableToMap.ts);
                    showFeatures(view, toShowFeatures);
                    setLoading(false);
                }).catch((err: any) => {
                    console.error('Unable get geometry');
                    const toShowFeatures = filterShowFeatures(tableToMap.ts);
                    showFeatures(view, toShowFeatures);
                    setLoading(false);
                })
            } else {
                tableSelection.current = tableToMap.ts;
                const toShowFeatures = filterShowFeatures(tableToMap.ts);
                showFeatures(view, toShowFeatures);
            }
        }
    }

    const filterShowFeatures = (ts: { [id: string] : __esri.Graphic | null }) => {
        return Object.values(ts).filter(v => v !== null) as __esri.Graphic[];
    }

    const isEqual = (feature: any, row: Row<any>) => {
        return feature.attributes.ID === row.original.attributes.ID && feature.attributes.RODZAJ_OBIEKTU === row.original.attributes.RODZAJ_OBIEKTU;
    }

    const compareId = (row1: Row<any>, row2: Row<any>) => {
        if(!row1.original.attributes){
            row1.original.attributes = row1.original;
        }
        if(!row2.original.attributes){
            row2.original.attributes = row2.original;
        }
        return row1.original.attributes.NUMER_IDENTYFIKACYJNY === row2.original.attributes.NUMER_IDENTYFIKACYJNY &&
        row1.original.attributes.RODZAJ_OBIEKTU === row2.original.attributes.RODZAJ_OBIEKTU &&
        row1.original.attributes.GLOBALID === row2.original.attributes.GLOBALID;
    }

    const handleThreeDotsDeleteKRClick = () => {
        if (checkboxesTable.length > 0) {
            setDeleteObj(true);
        }
    }

    const handleThreeDotsUpdateRecClick = () => {
        if (checkboxesTable.length > 0) {
            var krChecked = checkboxesTable.filter(item => item.original.attributes.RODZAJ_OBIEKTU === ObjectType.KRO || item.original.attributes.RODZAJ_OBIEKTU === ObjectType.KRTZ);
            var poChecked = checkboxesTable.filter(item => item.original.attributes.RODZAJ_OBIEKTU === ObjectType.POO || item.original.attributes.RODZAJ_OBIEKTU === ObjectType.POTZ);
            if (krChecked.length > 0) {
                setrowKRUpdate(krChecked);
                var has2007 = false;
                var has2020 = false;
                krChecked.forEach(item => {
                    var attrs = item.original.attributes;
                    if(attrs.WZOR && attrs.WZOR === 2007){
                        has2007 = true;
                    }
                    if(attrs.WZOR && attrs.WZOR === 2020){
                        has2020 = true;
                    }
                })
                if(!has2007 && has2020){
                    updateKR(krChecked);
                }
                else{
                    setmodalCardUpdate(true);
                }
            }
            else if (poChecked.length > 0) correctPO(poChecked);
        }
    }

    var columns = Object.keys(headersExtend).filter(item => item !== "TERYT" && item !== "POCZEKALNIA");

    var tableProps: TableProps = {
        columnAliases: headersExtend,
        columnHelper: createColumnHelper<HeadersTable>(),
        columnNames: columns,
        columnConfig: columnConfig.current,
        cellActions: cellAction,
        data: prepareData(),
        extraSelection: mapSelection,
        selection: selected,
        onTrClick: functionsPermissions.pointObjOnMap.active ? handleTrClick : undefined,
        rowCompare: isEqual,
        compareId: compareId,
        loading: loading,
        mockUp: false,
        firstColumnCheckbox: true,
        tableFiltersVisible: true,
        isPagination: true,
        allCount: allCount,
        pagination: pagination,
        setPagination: setPagination,
        pageCount: pageCount,
        setPageCount: setPageCount,
        onPaginationChange: onPaginationChange,
        shiftSelection: true,
        scrollable: true,
        threeDots: true,
        threeDotsProps: {
            menuItemClass: 'threeDotsMenuItem',
            table: ThreeDotsTableTypes.DataBase,
            deleteKROnClick: handleThreeDotsDeleteKRClick,
            updateRecOnClick: handleThreeDotsUpdateRecClick,
            addProtocolOnClick: handleThreeDotsAddProtocolClick
        }
    }

    const extraWhere = (feature: __esri.Graphic | null) => {
        return buildWhereFromMapToKr(feature);
    }

    const whereBuild = (filtersTable: FiltersTable[]) => {
        return filtersToQuery(filtersTable);
    }

    const getSort = () => {
        switch (sortConfigDb.sortType) {
            case SortType.Asc:
                return `${sortConfigDb.filterColumnName}`;
            case SortType.Desc:
                return `${sortConfigDb.filterColumnName} DESC`;
            case SortType.None:
                return 'ID';
        }
    }

    useEffect(() => {
        if (pagination.pageSize === 0) {
            return;
        }
        const query = new Query({
            outFields: ["RODZAJ_OBIEKTU,NUMER_IDENTYFIKACYJNY, NUMER_ROBOCZY, GMINA, POWIAT, WOJEWODZTWO, WZOR, DATA_OBS, TERYT, POCZEKALNIA, GLOBALID, ID"],
            returnGeometry: false,
            start: pagination.pageIndex*pagination.pageSize,
            num: pagination.pageSize,
            where: whereBuild(filtersTableDb),
            orderByFields: [getSort()]
        })
        setLoading(true);
        let _query = tableFeatureService({ url: api.featureServices.dataBase }, query, api.tableDefaultExcluding);
        _query.promise.then((res: any) => {
            setHeadersExtend(res.featureSet.headers);
            setFeatureSetExtend(res.featureSet.data);
            recalcPagination(res.count);
            setLoading(false);
        }).catch((err: any) => {
            if (err?.reason !== "cancel") {
                setLoading(false);
            }
        })
        return () => {
            _query.cancel();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [api.featureServices.dataBase, api.tableDefaultExcluding, filtersTableDb, pagination.pageIndex, pagination.pageSize, recalcPagination, reloadTable, sortConfigDb]);


    useEffect(() => {
        setSelected([]);
        if (!customMap.selected) {
            setMapSelection([]);
            return;
        }
        const query = new Query({
            outFields: ["*"],
            where: extraWhere(customMap.selected)
        })
        setLoading(true);
        let _query = queryFeatureSet({ url: api.featureServices.dataBase }, query, api.tableDefaultExcluding);
        _query.promise.then((featureSet: any) => {
            setMapSelection(featureSet.data);
            setLoading(false);
        }).catch((err: any) => {
            if (err?.reason !== "cancel") {
                setLoading(false);
            }
        })
        return () => {
            _query.cancel();
        }
    }, [api.featureServices.dataBase, api.tableDefaultExcluding, customMap.selected]);

    const setCancelClose = (cancel: boolean) => {
        setDeleteObj(false);
        if (cancel === false) {
            setCheckboxesTable([]);
        }
    }

    const refresh = () => {
        setReloadTable(!reloadTable);
    }

    return (
        <div className="dataBaseView">
            <DataBase style={iconStyle} />
            <h3 style={iconStyle} >Baza główna</h3>
            <div style={{ height: 'calc(100% - 77px)' }}>
                {pagination.pageSize !== 0 && <Table {...tableProps} />}
            </div>
            {functionsPermissions.showObjGeomOnMap.active &&
                <SlideoutWrapper icon={MapIcon} btnPos={SlideoutBtnPosition.Left}>
                    <WebMap config={api.mapComposition.dataBase} baseMap={api.baseMap} />
                </SlideoutWrapper>
            }
            {deleteObj && <DeleteTaskWindow rows={checkboxesTable} onClose={setCancelClose} reload={refresh} />}
            {modalCardUpdate && <UpdateRegistrationCardModal rows={rowKRUpdate} callback={callbackUpdateKR} onClose={onCloseModal} />}
        </div>
    )
}

export default DataBaseView;